import { render, staticRenderFns } from "./RemoteEditableOption.vue?vue&type=template&id=20e9eb74&scoped=true&"
import script from "./RemoteEditableOption.vue?vue&type=script&lang=ts&"
export * from "./RemoteEditableOption.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteEditableOption.vue?vue&type=style&index=0&id=20e9eb74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e9eb74",
  null
  
)

export default component.exports